import * as React from "react";
function ArrowNavFirstPageIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px",
    "data-rtl-flip": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22 22.285a.73.73 0 0 1-.22-.518V2.233c0-.194.079-.38.22-.518a.76.76 0 0 1 1.06 0c.141.137.22.324.22.518v19.534a.73.73 0 0 1-.22.518.76.76 0 0 1-1.06 0m11.02-3.117q.167.069.347.068a.88.88 0 0 0 .642-.266.896.896 0 0 0 0-1.284l-5.718-5.718 5.694-5.718a.895.895 0 0 0 0-1.284.91.91 0 0 0-1.284 0l-6.057 6.057a1.33 1.33 0 0 0-.364.945 1.3 1.3 0 0 0 .388.944l6.057 6.058a.9.9 0 0 0 .294.198Z"
  }));
}
export default ArrowNavFirstPageIcon;